import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import { PurgeDataPanel } from "@amtana/settings-client";

import { SETTINGS_CATALOGS } from "./model/settings-copy.ts";

export const settingsBrowserModule: BrowserModule = defineBrowserModule("settings")
  .withScreens({
    settings: {
      path: "/settings",
      title: phrase(SETTINGS_CATALOGS, "screenTitle"),
      layout: "app",
      load: () => import("./ui/sections/settings-screen.tsx"),
    },
  })
  .withLends([{ token: PurgeDataPanel, load: () => import("./ui/sections/purge-data-panel.tsx") }]);
